import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { ChevronRight } from 'lucide-react';
import { REPORTS } from './reports/reportsCatalog';

// The Reports list; each card opens a standalone report with its own date and time filter.
export default function Reports() {
  const navigate = useNavigate();
  return (
    <div className="p-6 w-full">
      <h1 className="font-display text-3xl font-semibold tracking-tight mb-6">Reports</h1>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {REPORTS.filter((r) => !r.hidden).map((r) => (
          <button
            key={r.key}
            type="button"
            onClick={() => navigate(`/reports/${r.key}`)}
            className="text-left focus:outline-none"
          >
            <Card className="h-full transition-colors hover:border-primary">
              <CardContent className="p-5">
                <div className="flex items-start justify-between">
                  <div className="rounded-md bg-accent p-2">
                    <r.Icon className="h-5 w-5 text-accent-foreground" />
                  </div>
                  <ChevronRight className="h-4 w-4 text-muted-foreground" />
                </div>
                <h3 className="mt-3 font-semibold text-foreground">{r.title}</h3>
              </CardContent>
            </Card>
          </button>
        ))}
      </div>
    </div>
  );
}
